import React, { useState } from "react";
import HeaderDashboardLogin from "../../../components/HeaderDashboardLogin";
import "./LoginPage.scss"
import { useAuth } from "../../../hooks/useAuth";
import * as api from "../../../services/apiService";

function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { login } = useAuth();

  async function handleLogin(event) {
    event.preventDefault();

    const response = await api.login({
      username: username, 
      password: password,
    });

    switch(response.status){
      case 200:
        setError("");
        const token = await response.text();
        login(token);
        break;
      case 400:
        setError("Datele introduse sunt greşite.");
        break;
      default:
        setError("A apărut o eroare.");
    }
  };

  return (
    <div id="login">
      <HeaderDashboardLogin />
        
      <div className="container">
        <div className="row justify-content-center">
          <div className="col col-md-6 col-lg-5">
            <form onSubmit={handleLogin}>
              <h2 className="pb-4">Login</h2>

              <div className="form-group">
                <input
                  type="text"
                  name="username"
                  placeholder="Utilizator"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="form-control"
                />
              </div>

              <div className="form-group">
                <input
                  type="password"
                  name="password"
                  placeholder="Parolă"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="form-control"
                />
              </div>
              
              {error && <p className="text-white text-sm mb-4">{error}</p>}
              
              <button 
                type="submit"
                className="btn btn-primary mb-2"
              >
                Login
              </button>
            </form>
          </div>
        </div>
      </div>

      <div></div>
    </div>
  );
}

export default LoginPage;
